(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.global = {
    attach: function (context, settings) {

    }
  };

})(jQuery, Drupal, drupalSettings);
